import type TrackReport from 'yux-track-report'
import track from '@share/utils/track'
let trackInstance: TrackReport | null = null

export const getTrackInstance = (_hostIsMM?: boolean): TrackReport | null => {
  if (import.meta.env.SSR) {
    return null
  }
  if (trackInstance) {
    return trackInstance
  }
  // 矩阵站：上报 cname 统一使用 QDpclog（不再区分 qdmm 女频）
  trackInstance = track('qdpc', {
    path: 'pclog',
    cname: 'QDpclog',
    server: 'QDPC',
    logName: 'pc_log',
  })
  return trackInstance
}

export const trackEvent = (
  eventName: string,
  properties: Record<string, unknown>,
  event: UIEvent | null | undefined,
  hostIsMM?: boolean,
): void => {
  if (import.meta.env.SSR) {
    return
  }
  let x = 0
  let y = 0
  if (event) {
    x = (event as { pageX?: number; pageY?: number })?.pageX || 0
    y = (event as { pageX?: number; pageY?: number })?.pageY || 0
  }
  if (!trackInstance) {
    trackInstance = getTrackInstance(hostIsMM)
  }
  const pid = properties?.pid ? properties.pid : window.pid
  trackInstance?.trackEvent(eventName, {
    pid,
    x,
    y,
    ...properties,
  })
}
